import { LiveTracking } from '../components/LiveTracking';

export const LiveTrackingPage = () => {
  return <LiveTracking />;
};
